import React from 'react'
import { node, string } from 'prop-types'
import NavLink from '../common/NavLink'

const NavButton = ({ icon, label, location }) => {
  const pathName = window.location.pathname;
  let navClass = 'crosstab2--nav--btn';
  if (pathName.includes(location)) {
    navClass += ' crosstab2--nav--btn--active';
  }

  return (
    <NavLink
      className={navClass}
      to={location}
      activeClassName="crosstab2--nav--btn--active"
    >
      {icon && <span className="crosstab2--nav--btn--icon">{icon}</span>}
      <span className="crosstab2--nav--btn--label">{label}</span>
    </NavLink>
  )
}

NavButton.propTypes = {
  icon: node,
  label: string,
  location: string,
}

export default NavButton